<div class="context-menu" (click)="toggleMenu(); $event.stopPropagation()">
  <!-- <qds-icon class="qds-icon" name="dots-3-vertical" size="small"></qds-icon> -->
  <qds-button
    #contextMenuBtn
    id="contextMenu"
    icon-name="dots-3-vertical"
    icon-only="true"
    size="small"
    importance="subdued"
    [title]="labels.more | translate"
  ></qds-button>
  <!-- <qds-tooltip target="#contextMenu"  trigger="pointerenter"  placement="bottom"> More </qds-tooltip> -->
</div>

<div *ngIf="isVisible" class="device-info-popup">
  <div class="device-info-popup-container">
    <div class="device-info-popup-content">
      <qds-button
        *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser && item?.assignedInstallerId === null"
        importance="emphasized"
        icon-name="person-gear"
        [text]="labels.shareDevice | translate"
        (click)="onShareDevice()"
      ></qds-button>
      <qds-button *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser && item?.assignedInstallerId" importance="destructive" icon-name="person-gear" [text]="labels.stopShareDevice | translate" (click)="onShareDevice()"></qds-button>

      <qds-button
        *ngIf="role === roles.enduser && item?.deviceType === 'REX' && !item.remoteLink"
        importance="emphasized"
        icon-name="person-computer-screen"
        [text]="labels.addRemoteLink | translate"
        (click)="addUpdateRemoteLink(item)"
      ></qds-button>
      <qds-button
        *ngIf="role === roles.enduser && item?.deviceType === 'REX' && item.remoteLink"
        importance="emphasized"
        icon-name="person-computer-screen"
        [text]="labels.updateRemoteLink | translate"
        (click)="addUpdateRemoteLink(item)"
      ></qds-button>
      <qds-button
        *ngIf="role === roles.installer && item?.deviceType === 'AIREdge'"
        importance="destructive"
        icon-name="circle-slash-within"
        [text]="labels.revokeDevice | translate"
        (click)="revokeDeviceModal()">
      </qds-button>

      <div *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser" class="device-info-divider"></div>
      <div class="device-info-row">
        <qds-list-item [kicker]="labels.ownerName | translate" [text]="item?.ownerName"></qds-list-item>
      </div>
      <div class="device-info-row">
        <qds-list-item [kicker]="labels.softwareVersion | translate" [subtitle]="item?.firmwareVersion ? '' : 'NA'" [text]="item?.firmwareVersion"></qds-list-item>
      </div>
      <div class="device-info-link-row">
        <div class="device-info-link-container">
          <div class="device-info-link">
            <span>
              <!-- <qds-label text="Technical Document Link" importance="standard"></qds-label> -->
              <a [href]="item?.deviceType === 'REX' ? 'https://www.eliwell.com/Family/Refrigeration-Expert-XP.html' : 'https://www.eliwell.com/en/'" target="_blank" rel="noopener noreferrer">
                {{labels.technicalDocumentLink | translate}}
              </a>
              <qds-icon class="qds-icon" name="arrow-top-right-on-square" iconLibrary="default"></qds-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="isDialogOpen">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <!-- <h3 class="se-dialiog-title">{{item?.name}} </h3> -->
      <qds-title *ngIf="!item?.assignedInstallerId" slot="title" layer="popup" [subtitle]="item?.name" level="root"> {{labels.shareDevice | translate}} </qds-title>
      <qds-title *ngIf="item?.assignedInstallerId" slot="title" layer="popup" [subtitle]="item?.name" level="root">{{labels.stopDeviceSharing | translate}} </qds-title>
      <!-- <qds-list-item slot="title" layer="popup" size="large" level="root" [subtitle]="item?.name" text="Share Device" showDivider="true"></qds-list-item> -->
      <qds-divider class="w-full" importance="standard" vertical="false" style="margin-top: 10px"></qds-divider>
    </div>
    <div class="se-dialog-body">
      <div class="email-field w-full">
        <qds-label [text]="labels.installerEmail | translate" required="true"></qds-label>
        <qds-input *ngIf="!item?.assignedInstallerId"
          type="email"
          class="txtSearch"
          size="standard"
          [placeholder]="labels.enterEmail | translate"
          class="w-full emailText"
          [value]="installerEmail"
          (qdsChange)="onCheckEmail($event)"
          style="--qds-theme-input-background: #222222; --qds-color-background-primary: #222222"
        ></qds-input>
        <qds-label *ngIf="item?.assignedInstallerId" [text]="item?.assignedInstallerEmail"> </qds-label>
        <qds-loader *ngIf="isCheckingEmail" size="hero" importance="standard" class="qds-loader"></qds-loader>
        <qds-form-message
          *ngIf="installerEmailValid && !isCheckingEmail"
          [text]="labels.installerEmailRecognized | translate"
          status="success"
          style="margin-bottom: 16px"
        ></qds-form-message>
        <qds-form-message
          *ngIf="!installerEmailValid && installerEmail && !isCheckingEmail"
          [text]="labels.installereMailNotRecognized | translate"
          status="error"
          style="margin-bottom: 16px"
        ></qds-form-message>
      </div>

      <div *ngIf="deviceLocation">
        <qds-title kicker="Location" level="subsection"> {{ deviceLocation }} </qds-title>
      </div>
      <div *ngIf="!deviceLocation">
        <qds-title kicker="Location" level="section" layer="accessory"> {{labels.notAvailable | translate}} </qds-title>
      </div>
      
      <div *ngIf="!item?.assignedInstallerId" style="display: flex; align-items: flex-start; gap: 0.5rem;">
        <img src="assets/warning.svg" style="margin-top: 0.313rem;"/>
        <qds-title layer="popup" level="subsection" [subtitle]="labels.deviceSharingDisclaimer | translate"></qds-title>
        
      </div>

      <div *ngIf="item?.assignedInstallerId" style="display: flex; align-items: flex-start; gap: 0.5rem;">
        <img src="assets/warning.svg" style="margin-top: 0.313rem;"/>
        <qds-title layer="popup" level="subsection" [subtitle]="labels.revokeDeviceSharingDisclaimer | translate"></qds-title>
        
      </div>
      
      <qds-checkbox *ngIf="!item?.assignedInstallerId"
        [text]="labels.isAgreementCheckboxLabel | translate"
        [checked]="isAgreementChecked"
        (qdsChange)="onCheckboxChange($event)"
        
      ></qds-checkbox>
      <!-- <qds-checkbox size="small" text="By proceeding with Stop Service, you will revoke the installers access to this Edge device. You will remain the only authorized user and the only one able to restore the installers access. " [checked]="isAgreementChecked" (qdsChange)="onCheckboxChange($event)" style="margin-top: 16px;"></qds-checkbox> -->
      <div *ngIf="item?.assignedInstallerId" style="display: flex; align-items: flex-start; gap: 0.5rem;">
        <qds-checkbox [checked]="isAgreementChecked"  (qdsChange)="onCheckboxChange($event, 'stopService')"> </qds-checkbox>
        <span class="stopServiceInfo">{{labels.isStopAgreementCheckboxLabel | translate}}</span>
      </div>
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" [text]="labels.cancel | translate" tabindex="0" (click)="onDialogClose()"></qds-button>
      <qds-button
        autofocus=""
        importance="emphasized"
        [text]="labels.confirm | translate"
        tabindex="0"
        [disabled]="!isFormValid"
        (click)="onShareConfirm()"
      ></qds-button>
    </div>
  </div>
</div>

<!-- <qds-dialog [open]="isRemoteLinkModal" closable (qdsClose)="onRemoteLinkDialogClose()">
    <qds-title slot="title" layer="popup" [subtitle]="item?.name" level="root"> </qds-title>
    <qds-divider class="w-full" importance="standard" vertical="false" style="margin-top: -27px;"></qds-divider>
    <label class="qds-controls qds-related remoteLink">
      <qds-label inline text="Enter Remote Link:"></qds-label>
      <qds-input class="entredRemoteLink" [value]="entredRemoteLink" (qdsInput)="entredRemoteLink = $event.target.value"></qds-input>
    </label>
    <div slot="footer" style="display: flex; justify-content: flex-end; gap: 8px; width: 100%;">
        <qds-button id="cancel" text="Cancel" tabindex="0" (click)="onRemoteLinkDialogClose()"></qds-button>
        <qds-button autofocus="" importance="emphasized" text="Save" tabindex="0" (click)="saveRex()"></qds-button>
    </div>
</qds-dialog> -->

<div class="se-dialog" *ngIf="isRemoteLinkModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ item?.name }}</h3>
    </div>
    <div class="se-dialog-body">
      <label class="qds-controls qds-related remoteLink">
        <qds-label inline [text]="labels.enterRemoteLink | translate"></qds-label>
        <qds-input
          class="entredRemoteLink"
          [value]="entredRemoteLink"
          (qdsInput)="entredRemoteLink = $event.target.value"
        ></qds-input>
      </label>
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" [text]="labels.cancel | translate" tabindex="0" (click)="onRemoteLinkDialogClose()"></qds-button>
      <qds-button autofocus="" importance="emphasized" [text]="labels.save | translate" tabindex="0" (click)="saveRex()"></qds-button>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="isRevokeDeviceModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      
      <qds-title layer="main" level="root" subtitle="{{ item?.name }}"> {{labels.leaveDeviceAccess | translate}} </qds-title>
    </div>
    <div class="se-dialog-body">

        <div class="row">
          <qds-label [text]="labels.deviceOwner | translate"></qds-label>
          <qds-label text="{{item?.ownerName}}"></qds-label>
        </div>
        <div style="display: flex; align-items: flex-start; gap: 0.5rem;">
          <img src="assets/warning.svg" width="20" height="20" style="margin-top: 0.313rem;"/>
          <qds-title layer="popup" level="subsection" [subtitle]="labels.reviceDeviceWarningLabel | translate">  </qds-title>
          <!-- <qds-checkbox [checked]="isAgreementChecked" (qdsChange)="onCheckboxChange($event, 'revokeDevice')" style="margin-top: 16px;"> </qds-checkbox> -->
          
        </div>
        <qds-checkbox
            [text]="labels.isRevokeAgreementCheckboxLabel | translate"
            [checked]="isRevokeAgreementChecked"
            (qdsChange)="onRevokeAgreementCheckboxChange($event)"
        ></qds-checkbox>
        
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" [text]="labels.cancel | translate" (click)="onRevokeModalClose()"></qds-button>
      <qds-button [disabled]="!isRevokeAgreementChecked" importance="emphasized" [text]="labels.confirm | translate" (click)="confirmRevokeDevice(item)"></qds-button>
    </div>
  </div>
</div>